module.exports = __webpack_public_path__ + "img/lando2.14c65b96.jpg";